import 'slick-carousel/slick/slick'

export default class OurImpactSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-our-impact-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.slick({
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                appendDots: $('.js-our-impact-slider-dots'),

                responsive: [
                    {
                        breakpoint: 1280,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 500,
                        settings: {
                            slidesToShow: 1,
                        }
                    },
                ]
            });
        }

    }

};

new OurImpactSlider();